import b from 'b_';
import cx from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import ReactDOM from 'react-dom';

import { SimpleCallback, PopupType } from '../../typings';
import { BUTTON_SIZE } from '../button/types';
import { GRAVITIES, POPUP_AXIS, POPUP_DIRECTIONS, POPUP_THEMES } from '../constants';
import DotsControl from '../dots-control/dots-control';
import { DOTS_CONTROL_ICON_DIRECTION, DOTS_CONTROL_VIEW } from '../dots-control/typings';
import Popup from '../popup/popup';

import Item from './__item/three-dots__item';
import { THREE_DOTS_ITEM_TYPE, THREE_DOTS_VIEW } from './typings';

import './three-dots.scss';

export interface ThreeDotsProps {
    children?: React.ReactNode | Array<React.ReactNode>;
    controlRef?: (ref?: React.ReactInstance | null) => void;
    controlMix?: string;
    controlSize?: BUTTON_SIZE;
    direction?: GRAVITIES;
    disabled?: boolean;
    iconDirection?: DOTS_CONTROL_ICON_DIRECTION;
    mix?: string;
    onClick?: SimpleCallback;
    popupProps?: Record<string, any>; // TODO: тайпинги для попапа
    view: THREE_DOTS_VIEW;
}

class ThreeDots extends React.Component<ThreeDotsProps> {
    static defaultProps = {
        direction: POPUP_DIRECTIONS.RIGHT,
        iconDirection: DOTS_CONTROL_ICON_DIRECTION.HORIZONTAL,
        view: THREE_DOTS_VIEW.CLEAR,
    };

    static Item = Item;
    static TYPES = THREE_DOTS_ITEM_TYPE;
    static ICON_DIRECTION = DOTS_CONTROL_ICON_DIRECTION;
    static VIEWS = THREE_DOTS_VIEW;

    componentDidMount() {
        if (this.popupRef) {
            //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: Хочет ReactNode вместo Element
            this.popupRef.setOwner(ReactDOM.findDOMNode(this.dotsControlRef));
        }
    }

    popupRef: PopupType | null;
    dotsControlRef: React.ReactInstance | null;

    handleDotsControlClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        const { disabled, onClick } = this.props;

        if (!disabled && this.popupRef) {
            this.popupRef.closeAllPopups();
            this.popupRef.toggle();
        }

        if (onClick) {
            onClick();
        }
    };

    handleModalToggle = ({ shown }: { shown: boolean }): boolean => {
        this.setState({ opened: shown });

        return false;
    };

    setDotsControlRef = (ref?: React.ReactInstance | null) => {
        this.dotsControlRef = ref ? ref : null;

        const { controlRef } = this.props;

        if (controlRef) {
            controlRef(ref);
        }
    };

    setPopupRef = (ref?: React.ReactInstance | null) => {
        this.popupRef = ref ? (ref as PopupType) : null;
        const { popupProps = {} } = this.props;
        const { ref: popupRef } = popupProps;

        if (popupRef) {
            popupRef(ref);
        }
    };

    mapViewToDotsControlView() {
        const { view } = this.props;
        switch (view) {
            case THREE_DOTS_VIEW.PSEUDO:
                return DOTS_CONTROL_VIEW.PSEUDO;
            case THREE_DOTS_VIEW.CLEAR:
                return DOTS_CONTROL_VIEW.CLEAR;
            default:
                return DOTS_CONTROL_VIEW.CLEAR;
        }
    }

    render() {
        const {
            disabled,
            iconDirection,
            mix,
            controlMix,
            controlSize,
            children,
            popupProps = {},
            direction,
        } = this.props;
        const { mix: popupMix, ...otherPopupProps } = popupProps;

        const popupPropsData = {
            autoclosable: true,
            mix: cx('three-dots__popup', popupMix),
            ref: this.setPopupRef,
            theme: POPUP_THEMES.CLEAN,
            axis: POPUP_AXIS.START,
            direction: direction,
            offsetTop: 44,
            offsetLeft: direction === POPUP_DIRECTIONS.RIGHT ? -46 : 48,
            onToggle: this.handleModalToggle,
            ...omit(otherPopupProps, ['ref']),
        };

        const dotsControlVew = this.mapViewToDotsControlView();

        return (
            <div className={cx('three-dots', mix)}>
                {!disabled && <Popup {...popupPropsData}>{children}</Popup>}
                <DotsControl
                    direction={iconDirection}
                    disabled={disabled}
                    mix={cx(controlMix, b('three-dots', 'dots-control', { disabled }))}
                    onClick={this.handleDotsControlClick}
                    ref={this.setDotsControlRef}
                    size={controlSize}
                    view={dotsControlVew}
                />
            </div>
        );
    }
}

export default ThreeDots;
